import { Component, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { GetStartedService } from 'src/app/services/get-started/get-started.service';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { WindowScrollService } from 'src/app/services/window-scroll/window-scroll.service';
import { ScreenSizeService } from 'src/app/services/screen-size/screen-size.service';

@Component({
    selector: 'xqnr-get-started-fixed',
    templateUrl: './get-started-fixed.component.pug',
    styleUrls: ['./get-started-fixed.component.scss'],
    standalone: false
})
export class GetStartedFixedComponent implements OnInit {
  @ViewChild('getStartedRef') getStartedRef: ElementRef;
  @ViewChild('formContainer') formContainer: ElementRef;

  containerWidth: number;
  containerHeight: number|'auto' = 'auto';

  constructor(
    private windowScroll: WindowScrollService,
    private backdrop: BackdropService,
    public getStarted: GetStartedService,
    private screenSize: ScreenSizeService
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: any): any {
    this.setContainerWidth();
    this.setContainerHeight();
  }

  ngOnInit(): void {
    this.setContainerWidth();
    this.setContainerHeight();

    // When the backdrop closes, the form should also close
    this.backdrop.active$.subscribe((activeState: boolean) => {
      if (activeState === false) this.getStarted.hide();
    });

    // The form's height needs to be set for the scrollbar to work,
    // Delay setting the height by the time of the animation so DOM is in place
    this.getStarted.active$.subscribe((activeState: boolean) => {
      if (activeState) {
        setTimeout(() => this.setContainerHeight(), 500);
        this.windowScroll.preventWindowScroll();
      } else {
        this.windowScroll.allowWindowScroll();
      }
    });
  }

  setContainerHeight() {
    const winHeight = window.innerHeight;

    const setTheFormHeight = () => {
      let yOffset = 300;

      if (this.screenSize.lte(this.screenSize.md)) yOffset = 150;

      this.containerHeight = (winHeight - yOffset);
    };

    // Push to end of queue to make sure scrollbar height calculates correctly
    setTimeout(setTheFormHeight, 0);
  }

  setContainerWidth() {
    this.containerWidth = this.getStartedRef.nativeElement.offsetWidth;
  }

  emitHide() {
    this.backdrop.hide();
    this.getStarted.hide();
  }

  formSubmitSuccess() {
    this.emitHide();
  }
}
